<template>
  <div class="branch-container">
    <div class="page_title">
      <div class="titele-box">
        <el-breadcrumb class="bread" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>我的资料</el-breadcrumb-item>
          <el-breadcrumb-item>修改密码</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="title">修改密码</div>
      </div>
    </div>
    <div class="user_info">
      <div class="info_box">
        <div class="content_box">
          <el-form
            ref="user_pass_form"
            :model="user_pass_form"
            label-width="100px"
            :rules="pass_rules"
          >
            <div class="pass_box">
              <el-form-item label="旧密码：" prop="old_pass">
                <el-input
                  placeholder="请输入旧密码"
                  v-model="user_pass_form.old_pass"
                  :type="passList[0].type"
                  minlength="8"
                  maxlength="16"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <div
                v-show="user_pass_form.old_pass != ''"
                :class="[
                  passList[0].passState
                    ? 'password-icon-by'
                    : 'password-icon-zy',
                ]"
                @click="passShowChange(0)"
              ></div>
            </div>

            <div class="pass_box">
              <el-form-item label="新密码：" prop="new_pass1">
                <el-input
                  placeholder="请输入新密码"
                  v-model="user_pass_form.new_pass1"
                  :type="passList[1].type"
                  minlength="8"
                  maxlength="16"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <div
                v-show="user_pass_form.new_pass1 != ''"
                :class="[
                  passList[1].passState
                    ? 'password-icon-by'
                    : 'password-icon-zy',
                ]"
                @click="passShowChange(1)"
              ></div>
            </div>

            <div class="pass_box">
              <el-form-item label="确认密码：" prop="new_pass2">
                <el-input
                  placeholder="请输入确认密码"
                  v-model="user_pass_form.new_pass2"
                  :type="passList[2].type"
                  minlength="8"
                  maxlength="16"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <div
                v-show="user_pass_form.new_pass2 != ''"
                :class="[
                  passList[2].passState
                    ? 'password-icon-by'
                    : 'password-icon-zy',
                ]"
                @click="passShowChange(2)"
              ></div>
            </div>

            <el-form-item style="margin-top: 48px">
              <el-button
                class="subbmit_btn"
                type="primary"
                @click="onSubmit"
                :loading="!submitState"
                >提交</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $modifypwd } from "@/api/index";
export default {
  data() {
    let passRules = (rule, value, callback) => {
      // 8-16位 大/小写英文数字混合，也可加特殊字符
      let filter = /^(?=.*[0-9\!@#\$%\^&\*])(?=.*[a-zA-Z]).{8,16}$/;
      if (filter.test(value)) {
        callback();
      }
      // else if (!isNaN(value)) {
      //   console.log(1);
      //   callback('不能输入纯数字');
      // }

      callback("请输入 8~16 位混合数字字符");
    };

    let pass2Rules = (rule, value, callback) => {
      if (this.user_pass_form.new_pass1 == value) {
        callback();
      }
      callback("两次输入的密码不一致！");
    };
    return {
      user_pass_form: {
        old_pass: "",
        new_pass1: "",
        new_pass2: "",
      },
      pass_rules: {
        old_pass: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
        ],
        new_pass1: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          // { min: 8, max: 16, message: '长度在 8 到 16 位混合数字字符', trigger: 'change'},
          { validator: passRules, trigger: ["blur", "change"] },
        ],
        new_pass2: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: pass2Rules, trigger: "blur" },
        ],
      },

      submitState: true,

      passList: [
        { type: "password", passState: true },
        { type: "password", passState: true },
        { type: "password", passState: true },
      ],
    };
  },
  methods: {
    // modifypwd
    modifypwd(params) {
      // console.log(params);
      $modifypwd(params)
        .then((res) => {
          // console.log(res);
          this.$message.success({ message: res.msg, showClose: true });
        })
        .catch((err) => {
          console.log(err);
          this.$message.error({ message: err, showClose: true });
        });
    },

    // 表单提交
    onSubmit() {
      this.submitState = false;
      this.$refs["user_pass_form"].validate((valid) => {
        if (valid) {
          let params = {
            oldpassword: this.user_pass_form.old_pass,
            newpassword: this.user_pass_form.new_pass1,
            confirmpw: this.user_pass_form.new_pass2,
          };
          this.modifypwd(params);
          this.submitState = true;
        } else {
          this.submitState = true;
          console.log("error submit!!");
          this.$message.error({
            message: "请输入完整的表单信息！",
            showClose: true,
          });
          return false;
        }
      });
    },

    //
    passShowChange(index) {
      this.passList[index].type =
        this.passList[index].type == "password" ? "text" : "password";
      this.passList[index].passState = !this.passList[index].passState;
    },
  },
};
</script>

<style lang="scss" scoped>
.titele-box {
  background-color: #fff;
  padding: 20px 30px;
  .title {
    font-size: 20px;

    font-weight: bold;
    margin-top: 22px;
    color: rgba(0, 0, 0, 0.85);
    opacity: 1;
  }
}
.user_info {
  width: 100%;
  height: calc(100% - 110px);
  padding: 24px;
  box-sizing: border-box;
  background: #f0f2f5;
  .info_box {
    width: 100%;
    height: 100%;
    background: #ffffff;
    position: relative;
  }
}

.content_box {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  height: 100%;
  padding-top: 48px;
}

.el-form-item {
  margin-bottom: 16px;
}
::v-deep {
  .subbmit_btn {
    background: $theme-color;
    border: 0;
    &:hover {
      opacity: 0.9;
    }
  }
  .el-breadcrumb__inner.is-link:hover {
    color: #e72535;
  }
}
.el-input {
  width: 400px;
}
.pass_box {
  position: relative;
}

.password-icon-zy {
  cursor: pointer;
  position: absolute;
  z-index: 888;
  right: 114px;
  top: 50%;
  transform: translateY(-50%);
  width: 14px;
  height: 9px;
  padding: 5px;
  background: url("../assets/icon/zy.png") no-repeat;
  background-size: 100% 100%;
}
.password-icon-by {
  cursor: pointer;
  position: absolute;
  z-index: 888;
  right: 114px;
  top: 50%;
  transform: translateY(-50%);
  width: 14px;
  height: 6px;
  background: url("../assets/icon/by.png") no-repeat;
  background-size: 100% 100%;
}

::v-deep
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 6px;
}

// 必填框 提示符
::v-deep {
  .el-form-item__label::before {
    content: "" !important;
    margin-right: 0px;
  }

  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
    content: "*";
    color: #f56c6c;
    margin-left: 6px;
  }
}
</style>
